import React, { useState, useEffect } from 'react';
import { AuthProvider } from './AuthContext';
import logo from './logo.png';

function App() {
  const [visibleLetters, setVisibleLetters] = useState(0);
  const [showLocation, setShowLocation] = useState(false);
  const text = "SOOOON!";

  useEffect(() => {
    const timer = setInterval(() => {
      setVisibleLetters(prev => {
        if (prev < text.length) {
          return prev + 1;
        } else {
          clearInterval(timer);
          setTimeout(() => setShowLocation(true), 500);
          return prev;
        }
      });
    }, 150);

    return () => clearInterval(timer);
  }, []);

  return (
    <AuthProvider>
      <div className="min-h-screen bg-primary font-montserrat text-white flex flex-col items-center justify-between pb-16 px-4">

        <div className="w-full flex justify-center -mt-4 md:-mt-8">
          <img
            src={logo}
            alt="Logo"
            className="h-64 md:h-80 object-contain mt-0"
          />
        </div>

        <div className="flex-5 flex items-center justify-center -mt-8 md:-mt-16">
          <div className="relative inline-block">
            <svg viewBox="0 0 100 30" preserveAspectRatio="none" className="absolute left-[-3%] right-[-3%] w-[106%] h-[75%] top-[62%] -translate-y-1/2 z-0 overflow-visible">
              {/* Primary organic swipe */}
              <path
                d="M 1,12 Q 25,7 50,13 T 99,11 L 98,22 Q 75,18 50,23 T 2,20 Z"
                fill="#9c1001"
                opacity="0.9"
                className="fill-secondary"
              />
              {/* Secondary overlapping dry brush effect path */}
              <path
                d="M 3,10 Q 28,16 53,9 T 97,14 L 96,21 Q 71,16 46,21 T 4,17 Z"
                fill="#9c1001"
                opacity="0.8"
                className="fill-secondary"
              />
            </svg>
            <h1 className="relative z-10 text-6xl md:text-9xl font-black tracking-wider text-white font-montserrat uppercase">
              {text.split('').map((letter, index) => (
                <span
                  key={index}
                  className={`inline-block transition-opacity duration-300 ${index < visibleLetters ? 'opacity-100' : 'opacity-0'
                    }`}
                >
                  {letter}
                </span>
              ))}
            </h1>
          </div>
        </div>

        <div className="w-full">
          <p className={`text-center text-base md:text-lg tracking-widest text-white font-montserrat font-thin transition-opacity duration-1000 ${showLocation ? 'opacity-100' : 'opacity-0'
            }`}>
            ERBIL-ANKAWA
          </p>
        </div>
      </div>
    </AuthProvider>
  );
}

export default App;